export default "__VITE_ASSET__DvzO$Zyn__"